import moment from "moment";
import React from "react";
import { useState } from "react";
import { useEffect } from "react";
import {
  Button,
  Col,
  Container,
  FormControl,
  Modal,
  Row,
} from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import Search from "../../Search/index";
import { postDataAPI } from "../../../services/apiWrapper";
import {
  downloadStudentList,
  getStudents,
} from "../../../store/actions/centerActions/studentAction";
import { courseType, examType } from "../../../utils/constant";
import NocApplyModal from "../Noc/NocApplyModal";

export default function Student() {
  const dispatch = useDispatch();
  const [modalOpen, setmodalOpen] = useState(false);
  const [adminCard, setAdminCard] = useState(false);
  const [admitCardUrl, setAdmitCardUrl] = useState("");
  const [studentModalId, setstudentModalId] = useState(false);
  const [totalPages, settotalPages] = useState(0);
  const [activePage, setactivePage] = useState(1);
  const [search, setSearch] = useState("");
  const [date, setDate] = useState("");
  const [nocStudent, setNocStudent] = useState(null);
  const [examStatus, setExamStatus] = useState({}); // LMS Part 10: studentId -> stage
  const { center } = useSelector((state) => state);
  const { students } = center;

  const token = localStorage.getItem("centerToken");

  useEffect(() => {
    dispatch(getStudents(token, activePage, search, date));
  }, [activePage, search, date]);

  useEffect(() => {
    if (students) {
      settotalPages(Math.ceil(students.total / students.per_page));
      // LMS exam status for the students on this page (read-only, one call).
      const ids = (students.data || []).map((s) => s.id);
      if (ids.length) {
        dispatch(postDataAPI("center/lms/exam-status", { student_ids: ids }, token))
          .then((res) => setExamStatus(res.data.data || {}))
          .catch(() => setExamStatus({}));
      }
    }
  }, [students]);

  const handleDownload = () => {
    dispatch(downloadStudentList(token, search, date));
  };

  return (
    <>
      <div class="Title-box">
        <div class="row">
          <div class="col-md-6">
            <div class="BigTitle">My Students</div>
          </div>
          <div class="col-md-6">
            <div class="CommanForm d-flex">
              <div class="btncomplt">
                <Link to="/center/add-student" class="btn btn-comman">
                  Add New Student
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mid-content-box">
        <div className="row">
          <div className="col-md-2"></div>
          <div className="col-md-4">
            <Search
              setQuery={(val) => {
                setSearch(val);
                setactivePage(1);
              }}
            />
          </div>
          <div className="col-md-4">
            <FormControl
              type="date"
              value={date}
              onChange={(e) => {
                setDate(e.target.value);
                setactivePage(1);
              }}
            />
          </div>
          <div className="col-md-2">
            <button
              onClick={handleDownload}
              className="btn btn-light-primary font-weight-bolder btn-sm"
            >
              Download list
            </button>
          </div>
        </div>
        <div class="Widthdata">
          <div class="Applicationdata s">
            <div class="row ">
              <div class="table-responsive">
                <table class="table">
                  <thead>
                    <tr>
                      <th>Sr No. </th>
                      <th> Student Name </th>
                      <th>Roll /Pdf </th>
                      <th>Course </th>

                      <th>Mobile </th>
                      <th>Reg.Date </th>
                      <th>Status </th>
                      <th>Exam Status </th>
                      <th>Photo </th>
                      <th>Registration Fee</th>
                      <th> Slips </th>
                      <th> Result </th>
                      <th> Membership </th>
                      <th> I Card </th>
                      <th> Action</th>
                      <th>Hall Ticket</th>
                      <th>NOC</th>
                    </tr>
                  </thead>
                  <tbody>
                    {students && students?.data?.length > 0 ? (
                      students.data.map((student, index) => (
                        <tr>
                          <td>{(activePage - 1) * 10 + index + 1}</td>
                          <td>{student.name}</td>
                          <td>{student.roll_number}</td>
                          <td>{student.course?.name || student.course}</td>
                          <td>{student.student_details?.mobile}</td>
                          <td>
                            {student.is_update == "1"
                              ? moment(student.register_date).format(
                                  "DD/MM/yyyy"
                                )
                              : moment(student.created_at).format("DD/MM/yyyy")}
                          </td>
                       
                          <td>
                            {Number(student.status) === 2 ? (
                              <>
                                <span className="badge badge-danger">
                                  Rejected
                                </span>
                                {student.reject_reason ? (
                                  <div
                                    className="text-danger"
                                    style={{ fontSize: "11px" }}
                                  >
                                    {student.reject_reason}
                                  </div>
                                ) : null}
                              </>
                            ) : (
                              <span className="badge badge-success">Active</span>
                            )}
                          </td>
                          <td>
                            {(() => {
                              const st = examStatus[student.id];
                              const tone = {
                                "Result Published": "success",
                                Appeared: "info",
                                Applied: "primary",
                                Eligible: "warning",
                                Pending: "secondary",
                              }[st] || "secondary";
                              return st ? (
                                <span className={`badge badge-${tone}`}>{st}</span>
                              ) : (
                                <span className="text-muted">—</span>
                              );
                            })()}
                          </td>
                          <td><a
                              title={student.profile_pic?.file}
                              target="_blank"
                              href={student.profile_pic?.file}
                              rel="noreferrer"
                            >
                              <img
                                height={"60px"}
                                width={"45px"}
                                src={student.profile_pic?.file}
                              />
                            </a></td>
                          <td>
                            {(() => {
                              // Paid when the council has the money. A payment
                              // record is the proof; the flag alone is not,
                              // because it used to be raised by the database
                              // default the moment a student was created.
                              const paidFees = student.submitFees || [];
                              const regFee =
                                paidFees.find(
                                  (f) => Number(f.registration_fee) > 0
                                ) || paidFees[0];
                              const paid = !!regFee || student.fee_status == 1;
                              const registrationSlip = regFee?.link;
                              if (!paid) return "Pending";
                              return (
                                <>
                                  Paid
                                  {registrationSlip && (
                                    <>
                                      {" "}
                                      <a
                                        href={registrationSlip}
                                        target="_blank"
                                        rel="noreferrer"
                                      >
                                        Slip
                                      </a>
                                    </>
                                  )}
                                </>
                              );
                            })()}
                          </td>
{/*                             
                          <td>
                              {student.submitFees?.length > 0 ? (
                                student.course?.exam_type ===
                                examType.course_wise ? (
                                  <a
                                    className="btn btn-success btn-sm"
                                    href={student.submitFees[0]?.link}
                                    target="_blank"
                                    rel="noreferrer"
                                  >
                                    Receipt
                                  </a>
                                ) : (
                                  <select onChange={handleDownload}>
                                    <option>--Select--</option>
                                    {student.submitFees.map((fee) => (
                                      <option value={fee.link}>
                                        {student.course?.course_type ===
                                        courseType.semester
                                          ? "Semester"
                                          : "Year"}{" "}
                                        {fee.semester}
                                      </option>
                                    ))}
                                  </select>
                                )
                              ) : (
                                "Pending"
                              )}
                            </td> */}
                          <td>
                            {/* every receipt of this student, listed */}
                            <Link to={`/center/students/slips/${student.id}`}>
                              View
                            </Link>
                          </td>
                          <td>
                            <Link to={`/center/students/result/${student.id}`}>
                              View
                            </Link>
                          </td>
                          <td>
                            {/* Membership option: only for courses the council
                                approved for membership AND a completed course.
                                Approved -> certificate; else the centre can apply. */}
                            {Number(student.membership_allowed) === 1 &&
                            Number(student.course_completed) === 1 ? (
                              student.membership_status === "Approved" ? (
                                <a
                                  className="btn btn-info btn-sm"
                                  href={`https://nsvec.com/api/public/Individual/MemberData/${encodeURIComponent(
                                    student.membership_reg_no ||
                                      student.roll_number
                                  )}`}
                                  target="_blank"
                                  rel="noreferrer"
                                >
                                  Member Certificate
                                </a>
                              ) : student.membership_status === "Pending" ? (
                                <span className="badge badge-warning">
                                  Membership Pending
                                </span>
                              ) : (
                                <>
                                  {student.membership_status === "Rejected" && (
                                    <div
                                      className="text-danger"
                                      style={{ fontSize: "11px" }}
                                    >
                                      Rejected
                                    </div>
                                  )}
                                  <Link
                                    className="btn btn-success btn-sm"
                                    to="/member/register"
                                    target="_blank"
                                  >
                                    Apply Membership
                                  </Link>
                                </>
                              )
                            ) : (
                              <span className="text-muted">-</span>
                            )}
                          </td>
                          <td>
                            <a
                             href={`https://nsvec.com/api/public/download/student/card/${student.id}`}
                              target="_blank"
                              rel="noreferrer"
                            >
                              View
                            </a>
                          </td>

                          <td>
                            {" "}
                            <Button
                              onClick={() => {
                                setstudentModalId(btoa(student.id));
                                setmodalOpen(true);
                              }}
                              className="btn-sm"
                            >
                              Registration Form
                            </Button>
                          </td>
                          <td>
                            {(() => {
                              // One card per term the student has an exam
                              // form for. The server names them - Semester 1,
                              // 2nd Year, or a single card for a course-wise
                              // course - so the list always matches the course.
                              const cards = student.admitCards || [];
                              const open = (url) => {
                                setAdmitCardUrl(url);
                                setAdminCard(true);
                              };

                              if (cards.length === 0) {
                                // No exam form yet. The card itself says so.
                                return (
                                  <Button
                                    onClick={() =>
                                      open(
                                        `https://nsvec.com/api/public/exam-ticket/${btoa(
                                          student.id
                                        )}`
                                      )
                                    }
                                    className="btn-sm"
                                  >
                                    Hall Ticket
                                  </Button>
                                );
                              }

                              if (cards.length === 1) {
                                return (
                                  <Button
                                    onClick={() => open(cards[0].url)}
                                    className="btn-sm"
                                  >
                                    {cards[0].label}
                                  </Button>
                                );
                              }

                              return (
                                <select
                                  className="form-control form-control-sm"
                                  value=""
                                  onChange={(e) => {
                                    if (e.target.value) {
                                      open(e.target.value);
                                      e.target.value = "";
                                    }
                                  }}
                                >
                                  <option value="">--Select--</option>
                                  {cards.map((card) => (
                                    <option key={card.url} value={card.url}>
                                      {card.label}
                                    </option>
                                  ))}
                                </select>
                              );
                            })()}
                          </td>
                          <td>
                            <Button
                              className="btn-sm"
                              onClick={() =>
                                setNocStudent({
                                  id: student.id,
                                  name: student.name,
                                })
                              }
                            >
                              NOC Apply
                            </Button>
                          </td>
                          {/* <td>
                            <Link to={`/center/edit-student/${student.id}`}>
                              Edit
                            </Link>
                          </td> */}
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={17}>{"No student Found"}</td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <ReactPaginate
          className="pagination mt-5 justify-content-center"
          previousClassName="page-item"
          nextClassName="page-item"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          nextLinkClassName="page-link"
          previousLinkClassName="page-link"
          activeClassName="active"
          //   marginPagesDisplayed={10}
          onPageChange={(e) => setactivePage(e.selected + 1)}
          pageCount={totalPages}
          forcePage={activePage - 1}
          // renderOnZeroPageCount={null}
        />
      </div>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={modalOpen}
        onHide={() => {
          setmodalOpen(false);
          studentModalId(false);
        }}
      >
        <Modal.Body>
          <Container>
            <Row>
              <Col xs={12} md={12} style={{ height: "80vh" }}>
                {studentModalId && (
                  <iframe
                    src={`https://nsvec.com/api/public/ViewHallticket/${studentModalId}`}
                    width={"100%"}
                    height={"100%"}
                  ></iframe>
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setmodalOpen(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={adminCard}
        onHide={() => {
          setAdminCard(false);
          studentModalId(false);
        }}
      >
        <Modal.Body>
          <Container>
            <Row>
              <Col xs={12} md={12} style={{ height: "80vh" }}>
                {admitCardUrl && (
                  <iframe
                    title="Admit card"
                    src={admitCardUrl}
                    width={"100%"}
                    height={"100%"}
                  ></iframe>
                )}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setAdminCard(false);
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      <NocApplyModal
        student={nocStudent || {}}
        show={!!nocStudent}
        onHide={() => setNocStudent(null)}
        onDone={() =>
          dispatch(getStudents(token, activePage, search, date))
        }
      />
    </>
  );
}
